export default (function () {
  function burgerMenu(selector) {
    var body = jQuery('body');
    var activeClass = 'nav-active';
    var header = jQuery(selector);
    var button = header.find('.nav-opener');
    button.on('click', function (e) {
      e.preventDefault();
      toggleMenu();
    });

    function toggleMenu() {
      body.toggleClass(activeClass);
    }

    jQuery(document).click(function (event) {
      if (!jQuery(event.target).closest('.navbar, .nav-opener').length) {
        jQuery('body').removeClass(activeClass);
      }
    });
    var win = $(window),
        doc = $('html'),
        resizeClass = 'resize-active',
        flag,
        timer;

    var removeClassHandler = function removeClassHandler() {
      flag = false;
      doc.removeClass(resizeClass);
    };

    var resizeHandler = function resizeHandler() {
      if (!flag) {
        flag = true;
        doc.addClass(resizeClass);
      }

      clearTimeout(timer);
      timer = setTimeout(removeClassHandler, 500);
    };

    win.on('resize orientationchange', resizeHandler);
  }

  burgerMenu('.header');
});